import { xhr } from '@/api/config/Repository'
import PenaltyInfoRepository from '../PenaltyInfoRepository'

import GetPenaltyInfoRequestDTO from '@/services/penaltyInfo/models/GetPenaltyInfoRequestDTO'
import GetPenaltyInfoResponseDTO from '@/services/penaltyInfo/models/GetPenaltyInfoResponseDTO'
import ExportPenaltyDetailsResponseDTO from '@/services/penaltyInfo/models/ExportPenaltyDetailsResponseDTO'

// Changes for France country
import GetPenaltyFRInfoRequestDTO from '@/services/penaltyInfo/models/GetPenaltyFRInfoRequestDTO'
import GetPenaltyFRInfoResponseDTO from '@/services/penaltyInfo/models/GetPenaltyFRInfoResponseDTO'
import GetPenaltyFRInfoLineRequestDTO from '@/services/penaltyInfo/models/GetPenaltyFRInfoLineRequestDTO'
import GetPenaltyFRInfoLineResponseDTO from '@/services/penaltyInfo/models/GetPenaltyFRInfoLineResponseDTO'
import DownloadPenaltyLineAttachmentRequestDTO from '@/services/penaltyInfo/models/DownloadPenaltyLineAttachmentRequestDTO'

export default class PenaltyInfoRepositoryImpl implements PenaltyInfoRepository {
  async getPenaltyInfo (request: GetPenaltyInfoRequestDTO): Promise<any> {
    const endpoint = `home/${request?.penaltyType.toLowerCase()}/fetch${request?.penaltyType}Detail/${request?.penaltyId}`
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.get<GetPenaltyInfoResponseDTO>(endpoint, { headers })
    return {
      status: response.status,
      result: response.data
    }
  }

  async getSLPPenaltyInfo (request: GetPenaltyInfoRequestDTO): Promise<any> {
    const endpoint = `${request?.penaltyType}/fetchSLPDetails/${request?.penaltyId}`
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const apiResponse = await xhr.get<any>(endpoint, { headers })

    return {
      status: apiResponse.status,
      result: apiResponse.data
    }
  }

  async getOrderDetails (request: any): Promise<any> {
    const endpoint = 'slp/fetchOrderDetailsByPenalty'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }

    const response = await xhr.post<any, any>(endpoint, request, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  async updateLpDetail (request): Promise<any> {
    let endpoint: string
    if (request?.penaltyType === 'LP') {
      endpoint = 'home/lp/updateLpDetail'
    } else if (request?.penaltyType === 'CP') {
      endpoint = 'home/cp/updateCpDetail'
    }
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const formData = request.data
    const response = await xhr.post<any, any>(endpoint, formData, { headers })
    console.log('LOG~ ~ file: PenaltyInfoRepositoryImpl.ts:59 ~ PenaltyInfoRepositoryImpl ~ updateLpDetail ~ response:', response)
    return {
      content: response.data,
      status: response.status
    }
  }

  async updateSLPDetail (request): Promise<any> {
    const endpoint = 'slp/savePenaltyDetails'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const formData = request.data
    const response = await xhr.post<any, any>(endpoint, formData, { headers })
    console.log('LOG~ ~ file: PenaltyInfoRepositoryImpl.ts:73 ~ PenaltyInfoRepositoryImpl ~ updateSLPDetail ~ response:', response)
    return {
      content: response.data,
      status: response.status
    }
  }

  async downloadPenaltyAttachment (request): Promise<any> {
    const endpoint = 'home/lp/download'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }

    const response = await xhr.post<any, any>(endpoint, request, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  async exportPenaltyDetails (penaltyID: string, penaltyType: string): Promise<ExportPenaltyDetailsResponseDTO> {
    let endpoint = ''
    if (penaltyType === 'slp') {
      endpoint = `${penaltyType.toLowerCase()}/export/${penaltyID}`
    } else {
      endpoint = `home/${penaltyType.toLowerCase()}/export/${penaltyID}`
    }
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.get<any>(endpoint, { headers })
    return {
      stream: response.data.stream,
      extension: response.data.extension,
      status: response.status
    }
  }

  // Changes for France country - LP Fetch
  async getPenaltyFRInfo (request: GetPenaltyFRInfoRequestDTO): Promise<GetPenaltyFRInfoResponseDTO> {
    const endpoint = 'france/lp/fetchLpFranceDetails'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<GetPenaltyFRInfoRequestDTO, any>(endpoint, request, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  async getPenaltyFRInfoLine (request: GetPenaltyFRInfoLineRequestDTO): Promise<GetPenaltyFRInfoLineResponseDTO> {
    const endpoint = 'france/lp/fetchLpLineDetails'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<GetPenaltyFRInfoLineRequestDTO, any>(endpoint, request, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  async exportPenaltyFRDetails (penaltyID: string, penaltyType: string): Promise<ExportPenaltyDetailsResponseDTO> {
    let endpoint = ''
    if (penaltyType === 'slp') {
      endpoint = `france/${penaltyType.toLowerCase()}/export/${penaltyID}`
    } else {
      endpoint = `france/${penaltyType.toLowerCase()}/export/${penaltyID}`
    }
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.get<any>(endpoint, { headers })
    return {
      stream: response.data.stream,
      extension: response.data.extension,
      status: response.status
    }
  }

  // Changes for France country - SLP Fetch
  async getSLPenaltyFRInfo (request: GetPenaltyFRInfoRequestDTO): Promise<GetPenaltyFRInfoResponseDTO> {
    const endpoint = 'france/slp/fetchSlpFranceDetails'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<GetPenaltyFRInfoRequestDTO, any>(endpoint, request, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  async getSLPenaltyFRInfoLine (request: GetPenaltyFRInfoLineRequestDTO): Promise<GetPenaltyFRInfoLineResponseDTO> {
    const endpoint = 'france/slp/fetchSlpLineDetails'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<GetPenaltyFRInfoLineRequestDTO, any>(endpoint, request, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  // Change for France country - Line Attachment Download
  async downloadPenaltyLineAttachment (request: DownloadPenaltyLineAttachmentRequestDTO): Promise<ExportPenaltyDetailsResponseDTO> {
    const endpoint = `france/common/lineAttachmentDownload?documentId=${request.documentId}&notificationType=${request.notificationType}&userType=${request.userType}`
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.get<any>(endpoint, { headers })
    return {
      stream: response.data.stream,
      extension: response.data.extension,
      status: response.status
    }
  }

  // Change for France Country - Update Penalty detail LP, SLP
  async updateFRPenaltyDetail (request): Promise<any> {
    let endpoint: string
    if (request?.penaltyType === 'LP') {
      endpoint = 'france/lp/saveLPFrancePenalty'
    } else if (request?.penaltyType === 'SLP') {
      endpoint = 'france/slp/saveSLPFrancePenalty'
    }
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const formData = request.data
    const response = await xhr.post<any, any>(endpoint, formData, { headers })
    console.log('LOG~ ~ file: PenaltyInfoRepositoryImpl.ts:73 ~ PenaltyInfoRepositoryImpl ~ updateFRPenaltyDetail ~ response:', response)
    return {
      content: response.data,
      status: response.status
    }
  }

  // Change for France Country - Update Penalty detail LP, SLP by Import Contestation
  async importLineContestFR (request): Promise<any> {
    let endpoint: string
    if (request?.penaltyType === 'LP') {
      endpoint = 'france/lp/updateLPImport'
    } else if (request?.penaltyType === 'SLP') {
      endpoint = 'france/slp/updateSLPImport'
    }
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const formData = request.data
    const response = await xhr.post<any, any>(endpoint, formData, { headers })
    console.log('LOG~ ~ file: PenaltyInfoRepositoryImpl.ts:73 ~ PenaltyInfoRepositoryImpl ~ importLineContestFR ~ response:', response)
    return {
      content: response.data,
      status: response.status
    }
  }
}
